export default __webpack_public_path__ + "static/media/speech_bubbles.7e1ffc43.png";